import { canShare, copyText, shareText } from './share';

const DEFAULT_CLIENT_APP_URL = 'http://mytraineroff.ru/';

export function getClientAppUrl(): string {
  const url = import.meta.env.VITE_CLIENT_APP_URL ?? DEFAULT_CLIENT_APP_URL;
  return url.endsWith('/') ? url : `${url}/`;
}

export function formatClientCredentials(
  login: string,
  password: string,
  appName = 'ProТренерофф',
): string {
  return `${appName} — данные для входа\nПриложение: ${getClientAppUrl()}\nЛогин: ${login}\nПароль: ${password}`;
}

export async function copyClientCredentials(
  login: string,
  password: string,
): Promise<void> {
  await copyText(formatClientCredentials(login, password));
}

export function canShareClientCredentials(): boolean {
  return canShare();
}

export async function shareClientCredentials(
  login: string,
  password: string,
  appName = 'ProТренерофф',
): Promise<void> {
  await shareText(formatClientCredentials(login, password, appName), appName);
}

export { isShareCancelled } from './share';
